var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "cloudfile-left v-height-flag" }, [
        _c("div", { staticClass: "mr15 ml15" }, [
          _vm.searchFlag
            ? _c(
                "div",
                { staticClass: "search-association" },
                [
                  _vm.searchList.length > 0
                    ? [
                        _c("div", [_vm._v("文件")]),
                        _vm._v(" "),
                        _vm._l(_vm.searchList, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "search-item",
                              class: _vm.isAcitive === index ? "isAcitive" : "",
                              on: {
                                mouseover: function ($event) {
                                  return _vm.mouseOver(index)
                                },
                              },
                            },
                            [
                              _c("span", [_vm._v("1")]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "keyword",
                                domProps: { innerHTML: _vm._s(item.name) },
                              }),
                            ]
                          )
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.searchList.length <= 0
                    ? _c("el-empty", { attrs: { description: "暂无数据" } })
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tab-name mr20 ml20" }, [
          _c("span", { staticClass: "name" }, [_vm._v("企业空间")]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "number p0" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: "创建企业空间",
                    effect: "dark",
                    placement: "top",
                  },
                },
                [
                  _c("span", {
                    staticClass: "iconfont icontianjia p0",
                    on: { click: _vm.addName },
                  }),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "name over-text m20",
            class: _vm.entIndex == "recently" ? "activeText" : "",
            on: {
              click: function ($event) {
                return _vm.entClick("recently", 0, "recently")
              },
            },
          },
          [
            _c("i", { staticClass: "icon iconfont iconzuijin" }),
            _vm._v(" "),
            _c("span", [_vm._v("最近打开")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showEntBtn,
                      expression: "showEntBtn",
                    },
                  ],
                  staticClass: "cloudfile-left-list",
                },
                _vm._l(_vm.entArray, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      class: _vm.entIndex === index ? "active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.entClick(index, item.id, item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "name over-text" }, [
                        _c("i", {
                          staticClass:
                            "icon iconfont iconrenshi-huibaoguanli-cebian",
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.name))]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _vm.entIndex === index
                            ? _c(
                                "el-popover",
                                {
                                  ref: "pop-" + item.id,
                                  refInFor: true,
                                  attrs: {
                                    offset: 10,
                                    placement: "bottom-end",
                                    trigger: "click",
                                  },
                                  on: {
                                    hide: _vm.handleHide,
                                    "after-enter": function ($event) {
                                      return _vm.handleShow(item.id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "right-item-list" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "right-item",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.addEdit(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$store.state.user.userInfo
                                                  .uid === item.uid
                                                  ? _vm.$t("public.edit")
                                                  : _vm.$t("public.check")
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.$store.state.user.userInfo.uid ===
                                      item.uid
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "right-item",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleDelete(item)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("public.delete")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "icon iconfont icongengduo right-icon",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "border-bottom" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "recovery",
            on: {
              click: function ($event) {
                return _vm.recoveryFn()
              },
            },
          },
          [_c("i", { staticClass: "iconfont iconshanchu1" }), _vm._v("回收站")]
        ),
      ]),
      _vm._v(" "),
      _c("space-dialog", {
        ref: "spaceDialog",
        attrs: { "from-data": _vm.fromData },
        on: { isOk: _vm.getEntList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }